export class LabelData {
  label?: string;
  name?: string;
  info?: string;
  validationErrorText?: string;
  isWhite?: boolean;
  isShort?: boolean;
  showInfo?: boolean;
  required?: boolean;
}

